import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { registerResource, resolveResource } from '../../store/screenSlice'
import { getIsVolumeOn } from '../../store/commonSlice'


const audioMap = {}

function AudioBody({
    audioRef,
    autoplay,
    loop,
    isVolumeOn,
    src,
    registerResource,
    resolveResource,
    onTimeUpdate,
}) {
    let audio = audioMap[src]

    if (!audio) {
        registerResource(src)
        audioMap[src] = new window.Audio(src)
        audio = audioMap[src]

        const interval = setInterval(() => {
            if (audio.readyState === 4) {
                clearInterval(interval)

                if (autoplay) {
                    audio.play()
                    resolveResource(src)
                } else {
                    audio.play()
                    audio.volume = 0

                    audio.ontimeupdate = () => {
                        audio.ontimeupdate = undefined
                        audio.pause()
                        audio.volume = isVolumeOn ? 1 : 0
                        audio.currentTime = 0

                        setTimeout(() => {
                            resolveResource(src)
                        }, 1000)
                    }
                }
            } else if (audio.error) {
                clearInterval(interval)
                resolveResource(src)
            }
        }, 100)
    }

    audio.volume = isVolumeOn ? 1 : 0
    audio.loop = Boolean(loop)
    audio.ontimeupdate = () => {
        if (onTimeUpdate) {
            onTimeUpdate(audio)
        }
    }

    if (typeof audioRef === 'function') {
        audioRef(audio)
    } else if (audioRef) {
        audioRef.current = audio
    }

    useEffect(() => {
        if (audio.readyState === 4 && autoplay) {
            audio.play()
        }
    }, [audio, autoplay])

    // Stop on exit
    useEffect(() => (
        () => {
            if (!audio.paused) {
                audio.pause()
            }
            audio.currentTime = 0
        }
    ), [audio])

    return null
}

AudioBody.propTypes = {
    audioRef: PropTypes.any,
    autoplay: PropTypes.bool,
    loop: PropTypes.bool,
    isVolumeOn: PropTypes.bool.isRequired,
    src: PropTypes.string.isRequired,
    registerResource: PropTypes.func.isRequired,
    resolveResource: PropTypes.func.isRequired,
    onTimeUpdate: PropTypes.func,
}

const Audio = connect(
    state => ({
        isVolumeOn: getIsVolumeOn(state),
    }), {
        registerResource,
        resolveResource,
    },
)(AudioBody)

Audio.propTypes = {
    audioRef: PropTypes.any,
    autoplay: PropTypes.bool,
    loop: PropTypes.bool,
    src: PropTypes.string.isRequired,
    onTimeUpdate: PropTypes.func,
}

export { Audio }
